import { EditorState, RichUtils } from "draft-js";

type Props = (state: EditorState, key: string) => EditorState;

const toggleBlockType: Props = (state, key) => {
  return RichUtils.toggleBlockType(state, key);
};

export default toggleBlockType;
